import { Backdrop, Box, Button, Slide, TextField } from "@mui/material"
import { avatarstylesx } from "../../../../../../core/styling/global";
import { Close } from "@mui/icons-material";
import realPropTemp from "../../../../../../assets/images/core/property-template.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { SnakeLoader } from "../../../../../../core/loader/SnakeLoader";

export const CustomPropTemplate = ({ templates, cmtznLoader }) => {
    const history = useHistory()
    const toCustomTemplate = () => {
        history.push(`/campaign/sales_page/real_property/attract/templates/customization/create?id=${templates.data.id}&section_id=${templates.data.section_id}`)
        cmtznLoader.set(true)
    }

    return (
        <Backdrop sx={{ justifyContent: 'center', alignItems: 'center', zIndex: 1305 }} open={templates.data.preview}>
            <Box display="flex" width={900} alignItems="flex-start" gap={1}>
                <Box borderRadius={3} bgcolor="#fff" p={3}>
                    <Box display="flex" gap={5}>
                        <Box sx={avatarstylesx(realPropTemp, 550, 390, 2)} />
                        <Box position="relative">
                            <Box fontSize={24} fontWeight={700}>Nature Website</Box>
                            <Box component={Button} onClick={() => toCustomTemplate()} bgcolor="#009F4D" color="#fff" px={4} mt={2} fontSize={12} sx={{ ':hover': { bgcolor: '#009F4D' } }} borderRadius={2}>Customize this template</Box>
                        </Box>
                    </Box>
                </Box>
                <Box component={Button} minWidth="" display="flex" bgcolor="#292D32" p={0.5} borderRadius={10} sx={{ ':hover': { bgcolor: '#292D32' } }}

                >
                    <Close sx={{ fontSize: 14, color: '#fff' }} onClick={() => templates.set(false)} />
                </Box>
            </Box>
        </Backdrop>
    )
}

export const TopButton = ({ t_form, openConfirm, error }) => {
    const td = t_form.data
    const cancelHandler = () => { 
        t_form.set({ ...td, submit: { modal: false, type: '', confirmed: false } })
        error.set({...error.data, confirmed: false})
     }
    const handlerOnChange = (e) => {
        const { name, value } = e.target
        t_form.set({ ...td, [name]: value })
    }
    const handleConfirm = () => {
        if (td.name === "") {
            error.set({...error.data, confirmed: true})
        }else{
            error.set({...error.data, confirmed: false})
            openConfirm.set(true)
        }
    }
   
    return (
        <Box>
            <Backdrop sx={{ justifyContent: 'center', alignItems: 'center', zIndex: 3503 }} open={td.submit.modal}>
                <Box display="flex" flexDirection="column" bgcolor="#fff" borderRadius={3} width={500} p={4} height={300} >
                    <Box color="#008000" fontSize={20} fontWeight={500}>Please! name your Real Property page.</Box>
                    <Box width="100%" pt={2}>
                        <Box mb={.5} display="flex" fontSize={16} fontWeight={550}>Name:<Box ml={1} fontSize={20} color="red">*</Box></Box>
                        <TextField size="small" fullWidth
                            name="name"
                            value={td.name}
                            error={error.data.confirmed && td.name === ""} helperText={error.data.confirmed && td.name === "" ? 'This field is required.' : ''}
                            onChange={(e) => handlerOnChange(e)}
                        />
                        {/* <Box mt={2} mb={.5} fontSize={16} fontWeight={550}>URL:</Box>
                        <TextField size="small" fullWidth
                            name="url"
                            onChange={(e) => handlerOnChange(e)}
                            value={td.url} 
                            error={error.data && td.url === ""} helperText={td.url === '' ? 'This field is required.': '' }
                        /> */}
                    </Box>
                    <Box display="flex" gap="8px" mt="auto" >
                        <Box component={Button} bgcolor="#E5F2EC" color="#009F4D" fontSize={14} fontWeight={600} border="1px solid #009F4D" width="50%" borderRadius="6px" sx={{ ':hover': { color: '#009F4D', bgcolor: '#E5F2EC' } }}
                            onClick={() => cancelHandler()}
                        >
                            Cancel
                        </Box>
                        <Box component={Button} bgcolor="#009F4D" color="#fff" fontSize={14} fontWeight={600} width="50%" borderRadius="6px" onClick={() => handleConfirm()}
                            sx={{ ':hover': { color: '#fff', bgcolor: '#009F4D' } }}
                        >
                            {!td.submit.confirmed ? td.submit.type === 1 ? 'Save' : 'Post' : <Box display="flex" alignItems="center">{td.submit.type === 1 ? 'Saving' : 'Posting'}</Box>}
                        </Box>
                    </Box>
                </Box>
            </Backdrop>
        </Box>
    )
}

export const Confirmation = ({ open, close, message, typeof_page, proceedHandler, t_form }) => {
    return (
        <Backdrop sx={{ justifyContent: 'center', alignItems: 'center', zIndex: 3503, pt: 40}} open={open}>
            <Slide in={open} direction='up'>
                <Box display="flex" flexDirection="column" bgcolor="#fff" alignItems="center" borderRadius={3} width={500} p={4}>
                    <Box fontSize={18} fontWeight={600}>{typeof_page} landing page?</Box>
                    <Box width="100%" pt={4}>
                        <Box textAlign="center" pb={2} fontSize={14} fontWeight={600}>{message}</Box>
                        <Box width="100%" display="flex" gap="8px" mt="auto" >
                            <Box component={Button} bgcolor="#E5F2EC" color="#009F4D" fontSize={14} fontWeight={600} border="1px solid #009F4D" width="50%" borderRadius="6px" sx={{ ':hover': { color: '#009F4D', bgcolor: '#E5F2EC' } }} onClick={close} >
                                Cancel
                            </Box>
                            <Box component={Button} bgcolor="#009F4D" color="#fff" fontSize={14} fontWeight={600} width="50%" borderRadius="6px" onClick={() => proceedHandler()}
                                sx={{ ':hover': { color: '#fff', bgcolor: '#009F4D' } }}
                            >
                                {!t_form.data.submit.confirmed ? t_form.data.submit.type === 1 ? 'Save' : 'Post' : <Box display="flex" alignItems="center">{t_form.data.submit.type === 1 ? 'Saving' : 'Posting'} <SnakeLoader size="5px" bg="#fff" distance="2.5px" /></Box>}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Slide>
        </Backdrop>
    )
}
